// extracted by mini-css-extract-plugin
export default {"scrollContainer":"TableProductWrapper_scrollContainer__o-MrX","gridContainer":"TableProductWrapper_gridContainer__xmqi1"};